import React from 'react';
import './Homeownership.css';

interface HomeownershipProps {
  headline: string;
  description: string;
  benefits: string[];
  cta: string;
  contactCta: string;
}

const Homeownership: React.FC<HomeownershipProps> = ({ 
  headline, 
  description, 
  benefits, 
  cta, 
  contactCta 
}) => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="homeownership">
      <div className="homeownership-container">
        <div className="homeownership-content">
          <div className="homeownership-left">
            <h2 className="homeownership-headline">
              {headline}
            </h2>
            <p className="homeownership-description">
              {description}
            </p>
            
            <ul className="homeownership-benefits">
              {benefits.map((benefit, index) => (
                <li key={index} className="benefit-item">
                  <span className="star">★</span>
                  {benefit}
                </li>
              ))}
            </ul>
            
            <div className="homeownership-ctas">
              <button 
                className="homeownership-cta primary"
                onClick={() => scrollToSection('contact')}
              >
                {cta}
              </button>
              <button 
                className="homeownership-cta secondary"
                onClick={() => scrollToSection('contact')}
              >
                <span className="contact-icon">💬</span>
                {contactCta}
              </button>
            </div>
          </div>
          
          <div className="homeownership-right">
            <div className="homeownership-image">
              <img 
                src="/assets/homeownership/family.jpg" 
                alt="Happy family in front of home" 
                className="family-image"
                onError={(e) => {
                  // Fallback to placeholder if image not found
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const placeholder = target.nextElementSibling as HTMLElement;
                  if (placeholder) placeholder.style.display = 'flex';
                }}
              />
              <div className="family-image-placeholder" style={{ display: 'none' }}>
                <div className="family-group">
                  <div className="person person-1"></div>
                  <div className="person person-2"></div>
                  <div className="person person-3"></div>
                  <div className="person person-4"></div>
                </div>
                <div className="house-background"></div>
                <div className="trees"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Homeownership;